import _defineProperty from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { deactivateAudioGraph } from '../helpers/deactivate-audio-graph';
import { testPromiseSupport } from '../helpers/test-promise-support';
var DEFAULT_OPTIONS = {
  numberOfChannels: 1
};
export var createMinimalOfflineAudioContextConstructor = function createMinimalOfflineAudioContextConstructor(cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, _startRendering) {
  return /*#__PURE__*/function (_minimalBaseAudioCont) {
    _inherits(MinimalOfflineAudioContext, _minimalBaseAudioCont);

    var _super = _createSuper(MinimalOfflineAudioContext);

    function MinimalOfflineAudioContext(options) {
      var _this;

      _classCallCheck(this, MinimalOfflineAudioContext);

      var _DEFAULT_OPTIONS$opti = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options),
          length = _DEFAULT_OPTIONS$opti.length,
          numberOfChannels = _DEFAULT_OPTIONS$opti.numberOfChannels,
          sampleRate = _DEFAULT_OPTIONS$opti.sampleRate;

      var nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate); // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.

      if (!cacheTestResult(testPromiseSupport, function () {
        return testPromiseSupport(nativeOfflineAudioContext);
      })) {
        nativeOfflineAudioContext.addEventListener('statechange', function () {
          var i = 0;

          var delayStateChangeEvent = function delayStateChangeEvent(event) {
            if (_this._state === 'running') {
              if (i > 0) {
                nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                event.stopImmediatePropagation();

                _this._waitForThePromiseToSettle(event);
              } else {
                i += 1;
              }
            }
          };

          return delayStateChangeEvent;
        }());
      }

      _this = _super.call(this, nativeOfflineAudioContext, numberOfChannels);
      _this._length = length;
      _this._nativeOfflineAudioContext = nativeOfflineAudioContext;
      _this._state = null;
      return _this;
    }

    _createClass(MinimalOfflineAudioContext, [{
      key: "length",
      get: function get() {
        // Bug #17: Safari does not yet expose the length.
        if (this._nativeOfflineAudioContext.length === undefined) {
          return this._length;
        }

        return this._nativeOfflineAudioContext.length;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
      }
    }, {
      key: "startRendering",
      value: function startRendering() {
        var _this2 = this;

        /*
         * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
         * the state of the nativeOfflineAudioContext might no transition to running immediately.
         */
        if (this._state === 'running') {
          return Promise.reject(createInvalidStateError());
        }

        this._state = 'running';
        return _startRendering(this.destination, this._nativeOfflineAudioContext).finally(function () {
          _this2._state = null;
          deactivateAudioGraph(_this2);
        });
      }
    }, {
      key: "_waitForThePromiseToSettle",
      value: function _waitForThePromiseToSettle(event) {
        var _this3 = this;

        if (this._state === null) {
          this._nativeOfflineAudioContext.dispatchEvent(event);
        } else {
          setTimeout(function () {
            return _this3._waitForThePromiseToSettle(event);
          });
        }
      }
    }]);

    return MinimalOfflineAudioContext;
  }(minimalBaseAudioContextConstructor);
};